import React, { useEffect, useState } from 'react'
import Select, { components } from 'react-select'
import { lang } from 'utils/helpers'

import OptionsBrands from './OptionsBrands'

import './styles.scss'

const SelectBrandsDelegations = ({
  multiple,
  selectDelegations,
  isClearable,
  brands,
  delegations,
  onChange,
  placeholder,
  options,
  totalDelegations,
  label,
  otherTooltipProps
}) => {
  const [selectedCenters, setSelectedCenters] = useState({
    brands: brands?.length ? [...brands] : [],
    delegations: delegations?.length ? [...delegations] : []
  })

  useEffect(() => {
    setSelectedCenters({
      brands: brands?.length ? [...brands] : [],
      delegations: delegations?.length ? [...delegations] : []
    })
  }, [brands, delegations])

  const handleChange = (value, data) => {
    if (data.action === 'clear') {
      setSelectedCenters({ brands: [], delegations: [] })
      onChange({ brands: [], delegations: [] })
      return
    }

    if (data.value === 'all') {
      setSelectedCenters({ brands: value.brands, delegations: value.delegations })
      onChange({ brands: value.brands, delegations: value.delegations })
      return
    }

    let updatedBrands = [...selectedCenters.brands]
    let updatedDelegations = [...selectedCenters.delegations]

    const isAllDelegationsChecked = data.delegations.every(delegation => delegation.isChecked)
    if (isAllDelegationsChecked) data.isChecked = true

    if (data.delegations.some(d => d.isChecked)) {
      if (!updatedBrands.some(it => it.value === data.value)) updatedBrands.push(data)
    } else {
      updatedBrands = deleteItem(data.value, updatedBrands)
    }

    for (const delegation of value) {
      if (delegation.isChecked) {
        updatedDelegations.push(delegation)
      } else {
        updatedDelegations = deleteItem(delegation?.value, updatedDelegations)
      }
    }

    setSelectedCenters({ brands: updatedBrands, delegations: updatedDelegations })
    onChange({ brands: updatedBrands, delegations: updatedDelegations })
  }

  const deleteItem = (value, items = []) => {
    const updatedItems = [...items]
    const index = updatedItems.findIndex(item => item.value === value)
    updatedItems.splice(index, 1)
    return updatedItems
  }

  const MultiValue = (props) => {
    return (
      <components.SingleValue {...props}>
        <span>
          {selectedCenters.delegations.length > 1
            ? `${selectedCenters.delegations.length} ${lang('label_selected')}`
            : selectedCenters.delegations[0]?.label || placeholder}
        </span>
      </components.SingleValue>
    )
  }

  return (
    <div
      className={`
        select-label-wrapper
        ${!label && 'normal-height'}
        mb-2
      `}
    >
      <div className='select-label-wrapper-inner'>
        {label ? <label>{lang(label)}</label> : null}
        <Select
          {...otherTooltipProps}
          options={options}
          className={`select-label-container`}
          classNamePrefix={'select-label'}
          placeholder={placeholder}
          isMulti={multiple}
          isClearable={isClearable}
          components={{ Option: OptionsBrands, MultiValue }}
          value={selectedCenters.delegations.length ? selectedCenters.delegations : null}
          onChange={handleChange}
          totalDelegations={totalDelegations}
          selectDelegations={selectDelegations}
          styles={{
            option: provided => ({
              ...provided,
              backgroundColor: '#ffffff',
              width: 22
            })
          }}
        />
      </div>
    </div>
  )
}

export default SelectBrandsDelegations
